export default "__VITE_ASSET__DXTjt$Gt__"